export default "__VITE_ASSET__PZlbIwGx__";